<template>
  <div>
    <div class="title">
      <span>
        Merci d'encourager nos commanditaires
      </span>
    </div>

    <b-carousel
        id="commanditaires"
        v-model="slide"
        :interval="2800"
        controls
        indicators
        background="#FFF"
        style="text-shadow: 1px 1px 2px #333;"
    >
      <a
          v-for="sponsor in sponsors"
          :key="sponsor.id"
          href="/commanditaires"
          target="_self"
      >
        <b-carousel-slide :img-src="sponsor.photo.url"/>
      </a>
    </b-carousel>
  </div>
</template>

<script>
  import _ from 'lodash';
  import SponsorsMixin from '@/components/Layout/Sponsors.mixin';

  export default {
    name: 'layout-sponsors',
    mixins: [ SponsorsMixin ],
    data() {
      return {
        slide: 0
      };
    }
  };
</script>

<style scoped lang="scss">
  #commanditaires {
    width: 220px;
    height: 180px;
  }

  .title {
    text-align: center;
    width: 220px;
    padding-bottom: 10px;
    font-size: 16px;
  }
</style>
